import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, ShieldAlert } from "lucide-react";

export default function VinRecallsBadge({ vin }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!vin) return;
    api.get(`/vin-alerts/recalls/${vin}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [vin]);
  if (!data || data.recall_count === 0) return null;
  return (
    <div className="rounded-xl border border-red-500/30 bg-red-500/5 p-4" data-testid="vin-recalls-panel">
      <div className="flex items-center gap-2 mb-2">
        <ShieldAlert className="w-4 h-4 text-red-400" />
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-red-300">{data.recall_count} Open NHTSA Recall{data.recall_count > 1 ? "s" : ""}</div>
      </div>
      <div className="space-y-2">
        {data.recalls.slice(0, 3).map((r, i) => (
          <div key={i} className="rounded-lg bg-slate-900/40 border border-red-500/20 p-2.5">
            <div className="flex items-center gap-2 mb-1"><AlertTriangle className="w-3 h-3 text-red-400" /><span className="text-xs font-bold">{r.campaign_number}</span><span className="text-[10px] text-slate-500">{r.component}</span></div>
            <div className="text-xs text-slate-300 line-clamp-2">{r.summary}</div>
          </div>
        ))}
      </div>
      <div className="text-[10px] text-slate-500 mt-2">Source: NHTSA · {data.cached_at?.slice(0, 10)}</div>
    </div>
  );
}
